import { StreamStatus } from '@amityco/js-sdk';
import React from 'react';
import StyledVideo from '../../../../core/components/Uploaders/Video/styles';
import useFile from '../../../../core/hooks/useFile';
import useStream from '../../../../core/hooks/useStream';
import LiveBadge from '../../../../social/components/LiveBadge';
import { LivestreamEndedThumbnail, LivestreamEndedVideoMessage, LivestreamIdleThumbnail, LivestreamIdleVideoMessage, LivestreamOverlayElements, LivestreamThumbnail, LivestreamTitle, RecordedBadge, } from './StreamItem.styles';
function getUrl(stream) {
    var _a, _b, _c, _d, _e;
    if (stream.status === StreamStatus.Live) {
        return (_b = (_a = stream.watcherUrl) === null || _a === void 0 ? void 0 : _a.hls) === null || _b === void 0 ? void 0 : _b.url;
    }
    if (stream.status === StreamStatus.Recorded) {
        return (_e = (_d = (_c = stream === null || stream === void 0 ? void 0 : stream.recordings) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.mp4) === null || _e === void 0 ? void 0 : _e.url;
    }
    return undefined;
}
export const Thumbnail = ({ item, showPlayIcon, showLivestreamRecordedBadge, showLivestreamTitle, }) => {
    var _a, _b, _c;
    const stream = useStream(item.data.streamId);
    const file = useFile(stream.thumbnailFileId);
    if (stream.status === StreamStatus.Idle || stream.isDeleted) {
        return React.createElement(LivestreamIdleThumbnail, null);
    }
    if (stream.status === StreamStatus.Ended) {
        return React.createElement(LivestreamEndedThumbnail, null);
    }
    return (React.createElement(LivestreamThumbnail, { duration: (_c = (_b = (_a = stream.recordings) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.mp4) === null || _c === void 0 ? void 0 : _c.duration, fileId: file === null || file === void 0 ? void 0 : file.fileId, overlayElements: React.createElement(LivestreamOverlayElements, null,
            stream.status === StreamStatus.Live && React.createElement(LiveBadge, null),
            showLivestreamRecordedBadge && stream.status === StreamStatus.Recorded && (React.createElement(RecordedBadge, null)),
            showLivestreamTitle && stream.title && React.createElement(LivestreamTitle, null, stream.title)), showPlayIcon: showPlayIcon }));
};
export const Item = ({ item }) => {
    const stream = useStream(item.data.streamId);
    if (!stream.streamId) {
        return null;
    }
    if (stream.status === StreamStatus.Idle || stream.isDeleted) {
        return React.createElement(LivestreamIdleVideoMessage, null);
    }
    if (stream.status === StreamStatus.Ended) {
        return React.createElement(LivestreamEndedVideoMessage, null);
    }
    return (React.createElement(StyledVideo, { isLive: stream.status === StreamStatus.Live, mediaFit: "contain", noBorder: true, url: getUrl(stream) }));
};
//# sourceMappingURL=StreamItem.js.map